function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
function useBookingSummary() {
  var _ref2, _redux$isAuthenticate, _redux$auth, _redux$dispatch;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    winnreAuth = _ref.winnreAuth,
    appType = _ref.appType,
    isPoints = _ref.isPoints;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    userAccountSummary = _useState2[0],
    setUserAccountSummary = _useState2[1];

  // allow the caller to either provide a flattened redux object or the full
  // `redux` prop coming from the parent.  most of our hosted apps keep auth
  // under `state.auth`, so check that first.  if no redux prop is given we
  // fall back to selectors so the hook can be used standalone (see
  // connectre version).
  var storeAuth = useSelector(function (state) {
    return state.auth || {};
  });
  var storeDispatch = useDispatch();
  var isAuthenticated = (_ref2 = (_redux$isAuthenticate = redux === null || redux === void 0 ? void 0 : redux.isAuthenticated) !== null && _redux$isAuthenticate !== void 0 ? _redux$isAuthenticate : storeAuth.isAuthenticated) !== null && _ref2 !== void 0 ? _ref2 : redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.isAuthenticated;
  var dispatch = (_redux$dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch) !== null && _redux$dispatch !== void 0 ? _redux$dispatch : storeDispatch;
  var authActions = (redux === null || redux === void 0 ? void 0 : redux.authActions) || {};
  useEffect(function () {
    if (isAuthenticated) {
      getUserAccountSummary();
    }
  }, [isAuthenticated]);
  var getUserAccountSummary = function getUserAccountSummary() {
    if (!winnreAuth) return;
    winnreAuth({
      method: "get",
      url: "/winnre/user/booking/account-summary"
    }).then(function (res) {
      var _res$data;
      console.log("CALL 2");
      // winnreAuth usually returns an axios response, so the actual
      // account summary is in `res.data`.  log the payload to make sure
      // we are storing the right object in state.
      var summary = (_res$data = res === null || res === void 0 ? void 0 : res.data) !== null && _res$data !== void 0 ? _res$data : res;
      console.log("SUMMARY", summary);
      setUserAccountSummary(summary);
      if (dispatch && authActions !== null && authActions !== void 0 && authActions.setRewardPoints) {
        dispatch(authActions.setRewardPoints(((summary === null || summary === void 0 ? void 0 : summary.rewardPoints) || 0) + ((summary === null || summary === void 0 ? void 0 : summary.unInvoicedCommission) || 0)));
        if (authActions !== null && authActions !== void 0 && authActions.setReloyRewardPoints) {
          dispatch(authActions.setReloyRewardPoints((summary === null || summary === void 0 ? void 0 : summary.reloyRewardPoints) || 0));
        }
      }
    })["catch"](function (e) {
      setUserAccountSummary(null);
    });
  };
  return {
    userAccountSummary: userAccountSummary,
    getUserAccountSummary: getUserAccountSummary
  };
}
export default useBookingSummary;